import React from 'react';

const SideBarTitle = ({ children }) => {
    return <span className='sidebar-brand'>{children}</span>;
};

export default SideBarTitle;
